import { request } from './core.api';

export interface ContractRenewalWorkflowItemDto {
  id: string;
  step: 'ExtendAgreement' | 'ContactTenant' | 'MarkUpcomingVacancy' | string;
  isCompleted: boolean;
  completedAtUtc?: string | null;
}

export interface ContractRenewalWorkflowDto {
  id: string;
  propertyId: string;
  propertyAddress: string;
  rentalAgreementId: string;
  tenantId: string;
  tenantName: string;
  endDate: string;
  daysRemaining: number;
  stage: 'WithinThreeMonths' | 'WithinSixMonths' | string;
  createdAt: string;
  updatedAt: string;
  items: ContractRenewalWorkflowItemDto[];
}

export interface UpdateContractRenewalWorkflowStepRequest {
  isCompleted: boolean;
  note?: string;
}

export const contractRenewalWorkflowsApi = {
  getByProperty: (propertyId: string) => request<ContractRenewalWorkflowDto[]>(`/properties/${propertyId}/contract-renewal-workflows`),
  updateStep: (workflowId: string, step: string, data: UpdateContractRenewalWorkflowStepRequest) =>
    request<ContractRenewalWorkflowDto>(`/contract-renewal-workflows/${workflowId}/steps/${step}`, { method: 'PUT', body: JSON.stringify(data) }),
};
